import { memo } from "react";
import { clsx } from "clsx";
import "./Radio.scss";

interface IRadioProps {
  label?: string;
  size?: "l" | "m" | "s";
  checked: boolean;
  disabled?: boolean;
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
}

export const Radio: React.FC<IRadioProps> = memo(({
  label,
  size = "l",
  checked,
  disabled,
  onChange,
  name,
  value
}) => {
  return (
    <label className={clsx(
      "Radio",
      `Radio_${size}`,
      disabled && "Radio_isDisabled",
    )} htmlFor={name} data-testid="radio">
      <input
        type="radio"
        name={name}
        value={value}
        id={name}
        aria-label={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <div className="Radio-Controls">
        <span
          className="Radio-CheckIcon" />
        <div className="Radio-Control"></div>
      </div>
      {label}
    </label>
  );
});
